module.exports = __webpack_public_path__ + "img/banner_description.c5f800c1.jpg";